import React from "react";
import Status from "../Status/Status";
import { Success } from "../../library/Icons/Icons";

const RegenerationSuccess: React.FC = () => (
  <Status size="lg" logo={<Success />} statusMessage={`A new link is on its way!`} subText={`Please check your email for the new link.`} />
);

export default RegenerationSuccess;
